<template>
  <white-bg style="min-height: 250px" padding="25px 30px">
    <preload-content :loading="!zones && !uptime" min-height="300px">
      <template v-if="zones && uptime">
        <h3>Загрузка</h3>
        <tabs :tabs="zones" @changeTab="changeTabs"/>
        <div class="loading">
          <span>{{ uptime }}</span>
        </div>
      </template>
    </preload-content>
  </white-bg>
</template>

<script>
import WhiteBg from '@/components/ui/white-bg'
import Tabs from '@/components/functional/Tabs'
import PreloadContent from '@/components/ui/preload-content';
import {mapGetters} from "vuex";

export default {
  name: "General",
  components: {PreloadContent, WhiteBg, Tabs},
  props: {
    period: Object,
  },
  data() {
    return {
      uptime: 0,
      zone: null,
      zones: null,
    }
  },
  watch: {
    period() {
      this.loadGeneral();
    },
    zone(to) {
      this.zone = to;
      this.loadGeneral();
    },
  },
  computed: {
    ...mapGetters(['getUser']),
    filter() {
      return Object.assign({zone_id: this.zone.id}, this.period);
    }
  },
  mounted() {
    this.loadZone();
  },
  methods: {
    loadGeneral() {
      this.$api.admin.analytic.general.info(this.filter).then((data) => this.uptime = `${data.uptime}%`);
    },
    loadZone() {
      this.$api.coworking.zone.list(this.getUser.coworking.id).then(({data}) => {
        data.unshift({id: '', name: 'Все'});
        this.zones = data;
        this.changeTabs(0);
      })
    },
    changeTabs(idx) {
      this.zones = this.zones.map((tab, tabIdx) => {
        tab.isActive = idx === tabIdx;
        if (tab.isActive) this.zone = tab;
        return tab;
      })
    },
  }
}
</script>

<style scoped lang="scss">
h3 {
  margin-bottom: 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
}

h4 {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #808080;
}

.card {
  padding: 15px;
  background: #FDF8F4;
  border: 1px solid #DBBFA7;
  box-sizing: border-box;
  border-radius: 10px;

  .main-income {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #383838;
  }

  .wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #383838;

    .col {
      width: 50%;
    }
  }
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FDF8F4;
  border: 1px solid #DBBFA7;
  border-radius: 10px;
  height: 180px;

  span {
    font-weight: 600;
    font-size: 40px;
    line-height: 1.4;
    color: #383838;
  }
}

@media screen and (max-width: 991px) {
  .whiteBg {
    padding: 15px !important;
  }
}
</style>
